import React, {Component} from 'react';
import {Col, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import {getMemberImage, request} from "../../util/APIUtils";
import {
    b64toBlob,
    deepCopyObject,
    filterTransactionTypes,
    getLabelByValue,
    showAxiosError,
    trimObject
} from "../../util/Helpers";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL, SERVER_IMAGE_PATH} from "../../constants";
import './Payment.css';
import {Button, DatePicker, input} from "antd";
import Select from "../../local_node_modules/react-select"
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import Dropzone from "react-dropzone";
import moment from "moment";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Maskedinput from "react-text-mask";
import FileSaver from "file-saver";
import LoadingIndicator from "../../common/LoadingIndicator";
import locale from 'antd/es/date-picker/locale/tr_TR';

class IncomeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            mode: 'create',
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            fieldsDisabled: false,
            isLoading: false,
            isNotOwner: false,
            incomeTypes: [],
            selectedMember: [],
            income: {
                id: null,
                notCreateReceipt: false,
                isMember: false,
                member: null,
                isCancelled: null,
                transactionTitle: null,
                transactionDefinition: null,
                transactionDate: null,
                amount: null,
                onlineTransactionCode: null,
                userId: null,
                transactionTypeId: null,
                transactionChannelId: null,
                accrualList: [],
                branchId: null,
                receivedBy: null,
                financialTransactionFileList: [],
                transactionItemList: [{
                    id: null,
                    itemDetail: null,
                    amount: null,
                    transactionChannelId: 1,
                    financialTransactionId: null,
                    transactionTypeId: 1
                }],
            },
            showAccrualSearchModal: false,
            accrualTotal: 0.00,
            selectedAccrual: {},
            channel: null,
            partialAccrual: 0,
            uyariModal:false,
        };

        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.saveIncome = this.saveIncome.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onChangeIncomeAmount = this.onChangeIncomeAmount.bind(this);
        this.onChangeIncome = this.onChangeIncome.bind(this);
        this.saveFile = this.saveFile.bind(this);
        this.downloadOriginalFile = this.downloadOriginalFile.bind(this);
        this.onChangeItemAmount = this.onChangeItemAmount.bind(this);
        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.onChangeItem = this.onChangeItem.bind(this);
        this.onItemSelectChange = this.onItemSelectChange.bind(this);
        this.calculate = this.calculate.bind(this);
        this.findIncomeTypes = this.findIncomeTypes.bind(this);
        this.onSelectAccrualInfoChange = this.onSelectAccrualInfoChange.bind(this);
        this.getMembers = this.getMembers.bind(this);
        this.getAccrualsByMemberId = this.getAccrualsByMemberId.bind(this);
        this.checkIncomeOverAccrualTotal = this.checkIncomeOverAccrualTotal.bind(this);
        this.getRelatedIncome = this.getRelatedIncome.bind(this);
        this.listOutStandingAccruals = this.listOutStandingAccruals.bind(this);
        this.cancelPaymentCreation = this.cancelPaymentCreation.bind(this);
    }

    async componentDidMount() {
        this.findIncomeTypes();
        let isNotOwner = true;
        let mod = "";
        let {channel} = this.props;
        let {selectedAccrual} = this.props;

        if (this.props.channel && this.props.channel === "income" && this.props.selectedIncome) {
            let selectedIncome = deepCopyObject(this.props.selectedIncome);
            let selectedMember = this.state.selectedMember;
            this.setState({isCancelled: selectedIncome.isCancelled});
            isNotOwner = (this.props.currentUser.realm !== this.props.selectedIncome.branchId);
            mod = deepCopyObject(this.props.mode);
            selectedIncome.transactionDate = (selectedIncome.transactionDate !== null) ? moment.utc(selectedIncome.transactionDate, "YYYY-MM-DD HH:mm:ss") : null;
            if (selectedIncome.member !== null) {
                selectedIncome.isMember = true;
                selectedMember.push(selectedIncome.member);
                this.checkMemberHasPartialAccrual(selectedIncome.member);
            }
            this.setState({
                mode: mod,
                income: selectedIncome,
                isNotOwner,
                channel,
                selectedMember
            }, () => this.calculate());

        } else if (this.props.channel && this.props.channel === "accrual" && this.props.selectedAccrual.financialTransactionId) {
            let selectedIncome = await this.getRelatedIncome();
            let selectedMember = this.state.selectedMember;
            isNotOwner = selectedIncome.branchId ? (this.props.currentUser.realm !== selectedIncome.branchId) : false;
            mod = deepCopyObject(this.props.mode);
            selectedIncome.transactionDate = (selectedIncome.transactionDate !== null) ? moment.utc(selectedIncome.transactionDate, "YYYY-MM-DD HH:mm:ss") : null;
            selectedIncome.isMember = true;
            if (selectedAccrual.member != null) {
                selectedMember.push(selectedAccrual.member);
                this.checkMemberHasPartialAccrual(selectedAccrual.member);
            }
            this.setState({
                mode: mod,
                income: selectedIncome,
                isNotOwner,
                selectedAccrual,
                channel,
                selectedMember
            }, () => this.calculate());

        } else if (this.props.channel && this.props.channel === "accrual" && !this.props.selectedAccrual.financialTransactionId) {
            isNotOwner = this.props.selectedAccrual.branchId ? (this.props.currentUser.realm !== this.props.selectedAccrual.branchId) : false;
            mod = deepCopyObject(this.props.mode);
            let selectedIncome = this.state.income;
            let selectedMember = this.state.selectedMember;
            selectedIncome.accrualList.push(this.props.selectedAccrual);
            selectedIncome.transactionTitle = this.props.selectedAccrual.member.ad + ' ' + this.props.selectedAccrual.member.soyad + ' - ' + this.props.selectedAccrual.member.odaSicilNo;
            selectedIncome.transactionItemList[0].itemDetail = (this.props.selectedAccrual.accrualType === 'RegistrationFee' ? 'Giriş Aidatı' : 'Yıllık Aidat') + '-' + this.props.selectedAccrual.relatedYear;
            selectedIncome.transactionItemList[0].transactionTypeId = (this.props.selectedAccrual.accrualType === 'RegistrationFee') ? 1 : 2;
            selectedIncome.transactionItemList[0].amount = this.props.selectedAccrual.amount;
            selectedIncome.transactionItemList[0].transactionChannelId = 1;

            selectedIncome.isMember = true;
            selectedMember.push(this.props.selectedAccrual.member);
            this.checkMemberHasPartialAccrual(this.props.selectedAccrual.member);

            this.setState({
                mode: mod,
                income: selectedIncome,
                isNotOwner,
                selectedAccrual,
                channel,
                selectedMember
            }, () => this.calculate());

        } else if (this.props.channel && this.props.channel === "member-accruals" && this.props.selectedMember) {
            console.log("this.props.selectedMember", this.props.selectedMember);
            let outstandingAccruals = await this.listOutStandingAccruals();

            isNotOwner = outstandingAccruals.length > 0 ? outstandingAccruals[0].branchId ? (this.props.currentUser.realm !== this.props.selectedMember.city.oda.id) : false : false;
            let income = deepCopyObject(this.state.income);
            let selectedMember = this.state.selectedMember;
            let transactionItemList = [];
            income.accrualList = outstandingAccruals.slice();
            income.transactionTitle = this.props.selectedMember.ad + ' ' + this.props.selectedMember.soyad + ' - ' + this.props.selectedMember.odaSicilNo;
            income.accrualList.map(item => {
                let transactionItem = {};
                transactionItem.id = null;
                transactionItem.transactionChannelId = 1;
                transactionItem.amount = item.amount;
                transactionItem.financialTransactionId = null;
                transactionItem.transactionTypeId = item.accrualType === 'RegistrationFee' ? 1 : 2;
                transactionItem.itemDetail = (item.accrualType === 'RegistrationFee' ? 'Giriş Aidatı' : 'Yıllık Aidat') + '-' + item.relatedYear;
                transactionItemList.push(transactionItem);
            });
            income.transactionItemList = transactionItemList;
            income.isMember = true;
            income.member = this.props.selectedMember;
            selectedMember.push(this.props.selectedMember);
            this.checkMemberHasPartialAccrual(this.props.selectedMember);
            console.log("income", income);
            this.setState({
                mode: mod,
                income: income,
                isNotOwner,
                selectedAccrual: this.props.selectedAccrual,
                channel,
                selectedMember
            }, () => this.calculate());

            if (outstandingAccruals.length < 1) {
                this.props.cancelProcess();
                let message = 'Tahsil edilecek borç bulunamadı!';
                Alert.error(message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });

            }

        }
        {
            const accrualDueDate = new Date(this.props.accrualDueDate);
            const today = new Date();
            const timeDifference = accrualDueDate - today;
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            if(daysDifference < 3){
                this.setState({
                    uyariModal: true,
                })
            }
        }

    }

    async getRelatedIncome() {
        let params = {
            url: API_BASE_URL + "/financial-transaction/" + Number(this.props.selectedAccrual.financialTransactionId),
            method: "get",
        };
        return request(params)
            .then(response => {
                return response.data;
            }).catch(function (error) {
                showAxiosError(error);
            });
    }

    async listOutStandingAccruals() {
        let params = {
            url: API_BASE_URL + "/accrual/outstandingAccrualsByMemberIdAndBranch/" + this.props.selectedMember.id,
            method: "get",
        };
        return request(params)
            .then(function (response) {
                console.log("outstandingAccruals;", response.data);
                return response.data;
            }).catch(function (error) {
                showAxiosError(error);
            });
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChangeIncome(e) {
        this.setState({
            income: {
                ...this.state.income,
                [e.target.name]: e.target.value
            }
        })
    }

    onChangeIncomeAmount(e) {
        this.setState({
            income: {
                ...this.state.income,
                [e.target.name]: e.target.value.toString().substring(0, e.target.value.length - 2)
            }
        })
    }

    onChangeIncomeDate(name, value) {

        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        let income = this.state.income;
        income[name] = value;
        this.setState({income});
    }

    onSelectChange(name, value) {
        let income = this.state.income;
        let items = income.transactionItemList;
        if (value === null) {
            income[name] = null
        } else {
            income[name] = value.value;
            for (let i = 0; i < items.length; i++) {
                if (items[i].itemDetail == null || items[i].itemDetail === "")
                    items[i].itemDetail = value.label;
            }
        }
        this.setState({income});

    }

    onItemSelectChange(name, value, index) {
        let income = this.state.income;
        let items = income.transactionItemList;
        if (value === null) {
            items[index][name] = null
        } else {
            items[index][name] = Number(value.value);
        }
        //
        this.setState({income});
    }

    saveIncome() {
        let self = this;
        let params;
        let data;
        let message;
        let income = deepCopyObject(this.state.income);
        let validity = this.validateComponent();
        let fileExists = false;
        let hasNonCashItem = false;
        let accrualTotalValid;


        if (income.transactionItemList.filter(item => item.transactionChannelId.toString() !== "1").length > 0) {
            hasNonCashItem = true;
        }

        if (income.financialTransactionFileList.length > 0) {
            fileExists = true;
        }

        // hiçbir kayıt aidat içermiyorsa kayıtların accrual listesi null olsun
        if ((income.transactionItemList) && (!income.transactionItemList.map(item => item.transactionTypeId).includes(1) && !income.transactionItemList.map(item => item.transactionTypeId).includes(2))) {
            income.accrualList = [];
        }

        if ((this.state.income.transactionItemList) && (this.state.income.transactionItemList.map(item => item.transactionTypeId).includes(1) || this.state.income.transactionItemList.map(item => item.transactionTypeId).includes(2))) {
            accrualTotalValid = this.checkIncomeOverAccrualTotal(this.state.partialAccrual);
        } else {
            accrualTotalValid = true;
        }

        if (validity.valid && accrualTotalValid && (!hasNonCashItem ? true : fileExists)) {
            self.setState({isLoading: true});
            income.userId = this.props.currentUser.id;
            if (this.props.currentUser.realm !== 0)
                income.branchId = this.props.currentUser.realm;
            income = trimObject(income);
            income.amount = income.amount.toString().replace(',', '.');
            for (const item of income.transactionItemList) {
                item.amount = item.amount.toString().replace(',', '.');
            }
            data = income;
            if (income.id === null) {
                message = 'Gelir Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/financial-transaction",
                    data: data,
                    method: 'post'
                };
            } else {
                message = 'Gelir Başarıyla Güncellendi.'
                params = {
                    url: API_BASE_URL + "/financial-transaction",
                    data: data,
                    method: 'patch'
                };
            }
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading: false});
                this.cancelProcess();
                self.props.handleSearch(self.props.searchQuery, true);
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        } else {
            let message = 'Hatalı veya eksik alanlar var!';
            if (!fileExists && hasNonCashItem) {
                message = message + '</br> Gelir Dosyası Seçiniz.'
            }
            if (!accrualTotalValid) {
                message = message + '</br> Toplam tahsilat en az seçtiğiniz tahakkukların bedeli kadar olmalıdır.'
            }
            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    cancelReceipt = () => {
        let params;
        let message;
        let income = deepCopyObject(this.state.income);
        let id = income.id;

        message = 'Gelir İptal Edildi.';
        params = {
            url: API_BASE_URL + '/financial-transaction/cancel/' + id,
            data: '',
            method: 'post'
        };

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            this.setState({isLoading: false});
            this.cancelProcess();
        }).catch(function (error) {
            showAxiosError(error);
        });
    };

    revertCancelReceipt = () => {
        let params;
        let message;
        let income = deepCopyObject(this.state.income);
        let id = income.id;

        message = 'Gelir İptali Geri Alındı.';
        params = {
            url: API_BASE_URL + '/financial-transaction/revert/' + id,
            data: '',
            method: 'post'
        };

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            this.setState({isLoading: false});
            this.cancelProcess();
        }).catch(function (error) {
            showAxiosError(error);
        });
    };

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = _ => resolve(reader.result);
            reader.onerror = e => reject(e);
        });
    }

    async onDrop(acceptedFiles) {
        let self = this;
        let income_ = this.state.income;
        income_.financialTransactionFileList = [];
        if (!!acceptedFiles) {
            self.setState({income_});
            let fileList = [];
            let content = null;
            let maxLength;
            (acceptedFiles.length >= 5) ? maxLength = 5 : maxLength = acceptedFiles.length;
            for (let i = 0; i < maxLength; i++) {
                content = await self.getBase64(acceptedFiles[i]);
                fileList.push({
                    id: null,
                    financial_transaction_id: income_.id,
                    content: content,
                    name: acceptedFiles[i].name,
                });

            }
            income_.financialTransactionFileList = fileList;
            self.setState({income_});
        }
    }

    saveFile(index) {
        let self = this;
        let fileName;
        let fileData;
        self.setState({isItemLoading: true});
        try {
            fileData = self.state.income.financialTransactionFileList[index].content.toString().substring(self.state.income.financialTransactionFileList[index].content.toString().lastIndexOf(',') + 1);
            fileName = self.state.income.financialTransactionFileList[index].name;
            let blob = b64toBlob(fileData, '');
            FileSaver.saveAs(blob, fileName);
            self.setState({isItemLoading: false});
        } catch (error) {
            self.setState({isItemLoading: false});
            showAxiosError(error);
        }
    }

    async downloadOriginalFile(index) {
        let self = this;
        let fileName;
        let financialTransactionFileList;
        financialTransactionFileList = self.state.income.financialTransactionFileList;
        fileName = financialTransactionFileList[index].name;

        if ((fileName !== null && fileName === "")) {
            self.setState({isItemLoading: true});
            await getMemberImage(SERVER_IMAGE_PATH + fileName).then(response => {
                financialTransactionFileList[index].content = response.data.base64File;
                self.setState({financialTransactionFileList});
                let blob = b64toBlob(response.data.base64File, '');
                FileSaver.saveAs(blob, fileName);
                self.setState({isItemLoading: false});
            }).catch(function (error) {
                self.setState({isItemLoading: false});
                showAxiosError(error);
            });
        }
    }

    addItem() {
        let income = this.state.income;
        if (income.transactionItemList.length < 3) {
            income.transactionItemList.push(
                {
                    id: null,
                    itemDetail: (this.state.incomeTypes.length > 0 && this.state.income.transactionTypeId) ? getLabelByValue(this.state.incomeTypes, this.state.income.transactionTypeId) : null,
                    amount: null,
                    transactionChannelId: "1",
                    financialTransactionId: null,
                    transactionTypeId: null
                });
            this.setState({income});
        }
    }

    removeItem() {
        let income = this.state.income;
        if (income.accrualList.length > 1) {
            income.accrualList.pop();
        }

        if (income.transactionItemList.length > 1) {
            income.transactionItemList.pop();
        }
        this.setState({income}, () => this.calculate());
    }

    calculate() {
        let totalAmount = 0;
        let income = this.state.income;
        for (let i = 0; i < income.transactionItemList.length; i++) {
            let val = income.transactionItemList[i].amount ? income.transactionItemList[i].amount.toString().replace(',', '.') : 0;
            totalAmount = (parseFloat(totalAmount) + parseFloat(val)).toFixed(2);
        }
        income.amount = parseFloat(totalAmount);
        this.setState({income});
        this.setState({income});
    }

    checkMemberHasPartialAccrual = (member) => {
        let params = {
            url: API_BASE_URL + '/financial-transaction/partialAccrual?memberId=' + member.id,
            method: 'get'
        };
        request(params).then((response) => {
            let partialAccrual = response.data;
            this.setState({partialAccrual: partialAccrual});
        }).catch(function (error) {
            showAxiosError(error);
        });
    };

    checkIncomeOverAccrualTotal(partialAccrual) {
        let accrualTotal = 0;
        let incomeTotal = 0;
        let income = this.state.income;
        for (let i = 0; i < income.transactionItemList.length; i++) {
            let val = income.transactionItemList[i].amount ? income.transactionItemList[i].amount.toString().replace(',', '.') : 0;
            incomeTotal = (parseFloat(incomeTotal) + parseFloat(val)).toFixed(2);
        }

        for (let i = 0; i < income.accrualList.length; i++) {
            let val = income.accrualList[i].amount ? income.accrualList[i].amount.toString().replace(',', '.') : 0;
            accrualTotal = (parseFloat(accrualTotal) + parseFloat(val)).toFixed(2);
        }

        if (partialAccrual && partialAccrual > 0)
            return parseFloat(incomeTotal) >= (parseFloat(accrualTotal) - parseFloat(partialAccrual)).toFixed(2);
        else
            return parseFloat(incomeTotal) >= parseFloat(accrualTotal);
    }

    onChangeItemAmount(e, index) {
        let totalAmount = 0;
        let income = this.state.income;
        income.transactionItemList[index][e.target.name] = e.target.value.toString().trim().substring(0, e.target.value.length - 2);
        this.calculate(income);
        for (let i = 0; i < income.transactionItemList.length; i++) {
            let val = income.transactionItemList[i].amount ? income.transactionItemList[i].amount.toString().replace(',', '.') : 0;
            totalAmount = (parseFloat(totalAmount) + parseFloat(val)).toFixed(2);
        }

        income.amount = parseFloat(totalAmount);
        this.setState({income});
    }

    onChangeItem(e, index) {
        let income = this.state.income;
        income.transactionItemList[index][e.target.name] = e.target.value;
        this.setState({income});
    }

    onChangeCheckBox(e) {
        const target = e.target;
        const value = target.checked;
        const name = target.name;

        this.setState((prevState) => {
            prevState.income[name] = value;
            return {
                income: prevState.income,
            };
        });
    }

    findIncomeTypes() {
        let incomeTypes = this.props.transactionTypes ? filterTransactionTypes(this.props.transactionTypes, "INCOME") : [];
        this.setState({incomeTypes});
    }

    onSelectAccrualInfoChange(e) {
        let income = this.state.income;
        let transactionItemList = [];
        if (e === null || !Array.isArray(e) || (Array.isArray(e) && e.length === 0)) {
            income.accrualList = [];
            income.transactionItemList = [{
                id: null,
                itemDetail: null,
                amount: null,
                transactionChannelId: 1,
                financialTransactionId: null,
                transactionTypeId: 1
            }];
        } else {
            income.accrualList = e.map(item => (item.data));
            e.map(item => {
                let transactionItem = {};
                transactionItem.id = null;
                transactionItem.transactionChannelId = 1;
                transactionItem.amount = item.data.amount;
                transactionItem.financialTransactionId = null;
                transactionItem.transactionTypeId = item.data.accrualType === 'RegistrationFee' ? 1 : 2;
                transactionItem.itemDetail = (item.data.accrualType === 'RegistrationFee' ? 'Giriş Aidatı' : 'Yıllık Aidat') + '-' + item.data.relatedYear;
                transactionItemList.push(transactionItem);
            });
            income.transactionItemList = transactionItemList;

            if (this.props.channel && this.props.channel === "accrual" && this.props.selectedAccrual) {
                if (income.accrualList.filter(item => item.id === this.props.selectedAccrual.id).length < 1) {
                    income.accrualList.push(this.props.selectedAccrual);
                }
            }
        }


        this.setState({income}, () => this.calculate());
    }

    onSelectMembersInfoChange = (e) => {
        let selectedMember;
        let income = this.state.income;

        if (e === null || !Array.isArray(e) || (Array.isArray(e) && e.length === 0)) {
            selectedMember = [];
        } else {
            selectedMember = e.map(item => (item.data));
            income.member = selectedMember[0];
            this.checkMemberHasPartialAccrual(income.member);
        }

        if (selectedMember.length > 0) {
            income.transactionTitle = selectedMember[0].ad + " " + selectedMember[0].soyad + " - " + selectedMember[0].odaSicilNo;
        }


        this.setState({selectedMember, income}, this.getAccrualsByMemberId);
    }

    getAccrualsByMemberId = () => {
        if (this.state.selectedMember.length > 0) {
            let params = {
                url: API_BASE_URL + "/accrual/byMemberId",
                method: "post",
                data: this.state.selectedMember[0].id
            };
            return request(params)
                .then((response) => {
                    return response.data;
                }).then((data) => {
                    return {
                        options: data.map(item => ({
                            label: item.member.odaSicilNo + " - " + item.member.ad.toLocaleLowerCase('tr') + ' ' + item.member.soyad.toLocaleLowerCase('tr') + ' - ' + (item.accrualType === 'YearlyFee' ? 'Yıllık Aidat' : 'Giriş Aidatı') + '-' + item.relatedYear + '-' + item.amount,
                            value: item.member.odaSicilNo + " - " + item.member.ad + ' ' + item.member.soyad + ' - ' + (item.accrualType === 'YearlyFee' ? 'Yıllık Aidat' : 'Giriş Aidatı') + '-' + item.relatedYear + '-' + item.amount,
                            data: item
                        }))
                    };
                });
        } else {
            return Promise.resolve({options: []});
        }
    }

    getMembers = (input) => {
        if (input.length > 4) {
            let params = {
                url: API_BASE_URL + "/uye/find-by-memberno/" + input.toLocaleLowerCase('tr'),
                method: "get",
            };
            return request(params)
                .then((response) => {
                    return response.data;
                }).then((data) => {
                    return {
                        options: data.map(item => ({
                            label: item.odaSicilNo + " - " + item.ad.toLocaleLowerCase('tr') + ' ' + item.soyad.toLocaleLowerCase('tr'),
                            value: item.odaSicilNo + " - " + item.ad + ' ' + item.soyad,
                            data: item
                        }))
                    };
                });
        } else {
            return Promise.resolve({options: []});
        }
    }
    cancelPaymentCreation() {
        this.setState({
            uyariModal: false,
        })
    }
    renderIsMember() {
        let tTransactionDate = this.state.income.transactionDate ? {value: this.state.income.transactionDate} : {};
        const numberMask = createNumberMask({
            prefix: '',
            suffix: ' ₺',
            allowDecimal: true,
            decimalSymbol: ',',
            includeThousandsSeparator: false,
        });
        let incomeTypes = [];
        if (this.props.channel && this.props.channel === "accrual")
            incomeTypes = this.state.incomeTypes.filter(item => item.value.toString() === "1" || item.value.toString() === "2");
        else
            incomeTypes = this.state.incomeTypes;

        return (
            <div className='financial-transaction-form-container'>
                {/* HEADER */}
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'/>
                <div className="card-body" style={{marginTop:"10px"}}>
                    <div className="FormRenk col-sm-12">

                        {(this.state.income.isTransferred && this.state.income.transferredTo && (this.state.income.transferredTo === this.props.currentUser.realm)) &&
                            <div className="col-sm-12">
                                <Label style={{
                                    color: "red",
                                    size: "10px"
                                }}>{"Bu gelir işlemi  " + moment(this.state.income.transferDate).format("DD.MM.YYYY") +
                                    " tarihinde " + this.props.allBranches.filter(item => item.value === this.state.income.branchId.toString())[0].label + " 'ndan odanıza transfer edilmiştir. Üzerinde Değişiklik Yapamazsınız!"}</Label>
                            </div>
                        }
                        {(this.state.income.isTransferred && this.state.income.transferredTo && (this.state.income.branchId !== this.props.currentUser.realm)) &&
                            <div className="col-sm-12">
                                <Label style={{
                                    color: "red",
                                    size: "10px"
                                }}>{"Bu gelir işlemi  " + moment(this.state.income.transferDate).format("DD.MM.YYYY") +
                                    " tarihinde " + this.props.allBranches.filter(item => item.value === this.state.income.branchId.toString())[0].label + " 'ndan " +
                                    this.props.allBranches.filter(item => item.value === this.state.income.transferredTo.toString())[0].label + " 'na transfer edilmiştir."}</Label>
                            </div>
                        }
                        <div className="col-sm-12 row">
                            <Label className="col-sm-3">Üye Seç: </Label>
                            <div className={"col-sm-9 form-group" + this.validateClass('tGrup')}>
                                <Select.Async
                                    multi={true}
                                    clearable={true}
                                    ignoreAccents={false}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    clearValueText="Temizle"
                                    placeholder={"Sicilno veya Ad-Soyad ile arama yapabilirsiniz."}
                                    noResultsText={"Sicilno veya Ad-Soyad ile arama yapabilirsiniz."}
                                    searchPromptText={"Sicilno veya Ad-Soyad ile arama yapabilirsiniz."}
                                    style={{flex: 1}}
                                    onChange={(e) => this.onSelectMembersInfoChange(e)}
                                    value={!(this.state.selectedMember === null || !Array.isArray(this.state.selectedMember) || (Array.isArray(this.state.selectedMember) && this.state.selectedMember.length === 0)) && this.state.selectedMember
                                        .map(item => ({
                                            label: item.odaSicilNo + " - " + item.ad + ' ' + item.soyad,
                                            value: item.odaSicilNo + " - " + item.ad + ' ' + item.soyad,
                                            data: item
                                        }))}
                                    loadOptions={this.getMembers}
                                />
                                {this.validateMessage('tGrup') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tGrup" delay={0}>
                                        {this.validateMessage("tGrup")}
                                    </UncontrolledTooltip>}
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Kişi/Şirket Adı: *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tTitle')}>
                                    <input className="form-control"
                                           type="text"
                                           name="transactionTitle"
                                           id="tTitle"
                                           data-vlength="1,255"
                                           onBlur={this.validateField}
                                           ref="tTitle"
                                           value={this.state.income.transactionTitle}
                                           onChange={(e) => this.onChangeIncome(e)}
                                    />
                                    {this.validateMessage('tTitle') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTitle" delay={0}>
                                            {this.validateMessage("tTitle")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tahsil Eden: *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tReceivedBy')}>
                                    <input className="form-control"
                                           type="text"
                                           name="receivedBy"
                                           id="tReceivedBy"
                                           maxLength="255"
                                           data-vlength="1,255"
                                           onBlur={this.validateField}
                                           ref="tReceivedBy"
                                           value={this.state.income.receivedBy}
                                           onChange={(e) => this.onChangeIncome(e)}
                                    />
                                    {this.validateMessage('tReceivedBy') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tReceivedBy" delay={0}>
                                            {this.validateMessage("tReceivedBy")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tarih: *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tTransactionDate')}>
                                    <DatePicker {...tTransactionDate}
                                                locale={locale}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="transactionDate"
                                                id="tTransactionDate"
                                                ref="tTransactionDate"
                                                inputProps={{'vdata': "required"}}
                                                onChange={(dateString) => this.onChangeIncomeDate("transactionDate", dateString)}
                                    />
                                    {this.validateMessage('tTransactionDate') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTransactionDate" delay={0}>
                                            {this.validateMessage("tTransactionDate")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  row">
                            <Label className="col-sm-3">E-Makbuz Üretilmesin</Label>
                            <div className={"col-sm-9 form-group"}>
                                <Label style={{color: 'red', fontSize: 'x-small'}}>
                                    <input
                                        type="checkbox"
                                        name="notCreateReceipt"
                                        checked={this.state.income.notCreateReceipt}
                                        onChange={(e) => this.onChangeCheckBox(e)}
                                        disabled={this.state.income.id}
                                    />
                                    {'  Sistem olmadığında elden verilen makbuzların yüklenmesi için geçerlidir!'}
                                </Label>
                            </div>
                        </div>
                        {this.state.selectedMember && <div className="col-sm-12  row">
                            <Label className="col-sm-3">Tahakkuk Seç: </Label>
                            <div className={"col-sm-9 form-group"}>
                                <Select.Async
                                    multi={true}
                                    clearable={true}
                                    ignoreAccents={false}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    clearValueText="Temizle"
                                    placeholder={"Tahakkuk seçmek için Sicilno veya Ad-Soyad ile arama yapabilirsiniz."}
                                    noResultsText={"Üyeye ait başka ödenmemiş tahakkuk bulunmamaktadır."}
                                    searchPromptText={"Tahakkuk seçmek için Sicilno veya Ad-Soyad ile arama yapabilirsiniz."}
                                    style={{flex: 1}}
                                    onChange={(e) => this.onSelectAccrualInfoChange(e)}
                                    value={this.state.income.accrualList.length > 0 && this.state.income.accrualList
                                        .map(item => ({
                                            label: item.member.odaSicilNo + " - " + item.member.ad + ' ' + item.member.soyad + ' - ' + (item.accrualType === 'YearlyFee' ? 'Yıllık Aidat' : 'Giriş Aidatı') + '-' + item.relatedYear + '-' + item.amount,
                                            value: item.member.odaSicilNo + " - " + item.member.ad + ' ' + item.member.soyad + ' - ' + (item.accrualType === 'YearlyFee' ? 'Yıllık Aidat' : 'Giriş Aidatı') + '-' + item.relatedYear + '-' + item.amount,
                                            data: item
                                        }))}
                                    loadOptions={this.getAccrualsByMemberId}
                                />
                            </div>
                        </div>}
                        {this.state.income.transactionItemList && this.state.income.transactionItemList.map((transactionItem, index) =>
                            <div>
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-3">
                                        {(index === 0) && <label>Gelir Kalemleri:*</label>}
                                    </div>
                                    <div className="col-sm-1">
                                        <label style={{fontWeight: "bold"}}>{index + 1 + ":"}</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className={"form-group" + this.validateClass('tItemDetail' + index)}>
                                            <input className="form-control"
                                                   placeholder="Açıklama"
                                                   type="text"
                                                   name={"itemDetail"}
                                                   id={"tItemDetail" + index}
                                                   maxLength="50"
                                                   data-vlength="1,255"
                                                   onBlur={this.validateField}
                                                   ref={"tItemDetail" + index}
                                                   value={transactionItem.itemDetail}
                                                   onChange={(e) => this.onChangeItem(e, index)}
                                            />
                                            {this.validateMessage('tItemDetail' + index) !== "" &&
                                                <UncontrolledTooltip placement="right" target={"tItemDetail" + index}
                                                                     delay={0}>
                                                    {this.validateMessage("tItemDetail" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className={"form-group" + this.validateClass('tTransactionType' + index)}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Gelir Tipi Seçiniz."
                                                name={"tTransactionType" + index}
                                                //style={{ width: 250}}
                                                inputProps={{'vdata': "required"}}
                                                ref={"tTransactionType" + index}
                                                id={"tTransactionType" + index}
                                                options={incomeTypes}
                                                onChange={(value) => this.onItemSelectChange("transactionTypeId", value, index)}
                                                value={this.state.income.transactionItemList[index].transactionTypeId}
                                            />
                                            {this.validateMessage('tTransactionType' + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"tTransactionType" + index}
                                                                     delay={0}>
                                                    {this.validateMessage("tTransactionType" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 row">
                                    <div className="col-sm-3"/>
                                    <div className="col-sm-1"/>
                                    <div className="col-sm-4">
                                        <div
                                            className={"form-group" + this.validateClass('tTransactionChannel' + index)}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Gelir Kanalı Seçiniz."
                                                name={"tTransactionChannel" + index}
                                                //style={{ width: 250}}
                                                ref={"tTransactionChannel" + index}
                                                id={"tTransactionChannel" + index}
                                                inputProps={{'vdata': "required"}}
                                                options={this.props.transactionChannels}
                                                onChange={(value) => this.onItemSelectChange("transactionChannelId", value, index)}
                                                value={this.state.income.transactionItemList[index].transactionChannelId}
                                            />
                                            {this.validateMessage('tTransactionChannel' + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"tTransactionChannel" + index} delay={0}>
                                                    {this.validateMessage("tTransactionChannel" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className={"form-group" + this.validateClass('tAmount' + index)}>
                                            <Maskedinput className="form-control"
                                                         mask={numberMask}
                                                         type="text"
                                                         name={"amount"}
                                                         id={"tAmount" + index}
                                                         inputProps={{vdata: "required", vlength: '3,12'}}
                                                         placeholder="________,__₺"
                                                         onBlur={this.validateField}
                                                         ref={"tAmount" + index}
                                                         value={transactionItem.amount && transactionItem.amount.toString().replace('.', ',') + ' ₺'}
                                                         onChange={(e) => this.onChangeItemAmount(e, index)}
                                            />
                                            {this.validateMessage('tAmount' + index) !== "" &&
                                                <UncontrolledTooltip placement="right" target={"tAmount" + index}
                                                                     delay={0}>
                                                    {this.validateMessage("tAmount" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                {(this.state.income.transactionItemList.length !== index + 1) &&
                                    <div className='col-sm-12 row'>
                                        <div className="col-sm-3"/>
                                        <div className="col-sm-1"/>
                                        <div className="col-sm-8">
                                            <hr/>
                                        </div>
                                    </div>}
                            </div>
                        )}
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3"/>
                            <div className="col-sm-6">
                                <button className='add-new-item' onClick={() => {
                                    this.addItem()
                                }}/>
                                <button className='remove-item' onClick={() => {
                                    this.removeItem()
                                }}/>
                            </div>

                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Toplam Tutar:</label>
                            </div>
                            <div className="col-sm-5">
                                <div className="kjhkjh">
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <Maskedinput className="form-control"
                                             mask={numberMask}
                                             type="text"
                                             disabled={true}
                                             name="totalAmount"
                                             id="tTotalAmount"
                                             placeholder="________,__₺"
                                             value={this.state.income.amount && this.state.income.amount.toString().replace('.', ',') + ' ₺'}
                                />
                            </div>
                        </div>

                        <div className='col-sm-12 row mt-2'>
                            <div className="col-sm-3">
                                <label>Gelir Dosyaları: *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tTransactionFile')}>
                                    <Dropzone
                                        accept=".pdf, .jpeg, .jpg, .png"
                                        activeClassName="dropzoneActiveClass"
                                        className="FormRenk3 col-sm-12"
                                        multiple={true}
                                        onDrop={this.onDrop}
                                        id="tTransactionFile"
                                    >
                                        <div className="dropzoneInnerArea row">
                                            <img alt="" className="add" src={require('../../icons8-plus-48_blue.png')}/>
                                            <span className="dropzoneInnerAreaText">Dosya(.pdf, .jpeg, .png) yüklemek için tıklayınız.</span>
                                        </div>
                                    </Dropzone>
                                    <Row>
                                        <Col sm="12" style={{
                                            paddingTop: "0px",
                                            paddingRight: "15px",
                                            paddingLeft: "15px",
                                            maxHeight: '500px',
                                            overflow: "auto"
                                        }}>
                                            <table className="" style={{textAlign: 'center', paddingBottom: "5px", width:"100%"}}>
                                                <thead>
                                                <tr style={{backgroundColor: '#ebedf0'}}>
                                                    <th width="5%">#</th>
                                                    <th>Dosya Adı:</th>
                                                    <th width="10%">Görüntüle</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.income.financialTransactionFileList && this.state.income.financialTransactionFileList.map((document, index) =>
                                                    <tr key={index + "_" + document.name + "_"}>
                                                        <td>{index + 1}</td>
                                                        <td style={{margin: "0px", textAlign: "left"}}>{
                                                            <TextOverFlowTooltip text={document.name || "-"}
                                                                                 maxLength={30}/>}</td>
                                                        <td style={{margin: "0px"}}>{<Button
                                                            className={this.state.isItemLoading ? 'preview-button-loading' : 'preview-button'}
                                                            disabled={this.state.isItemLoading}
                                                            onClick={async () => {
                                                                (this.state.income.financialTransactionFileList[index].content !== '')
                                                                    ?
                                                                    this.saveFile(index)
                                                                    :
                                                                    await this.downloadOriginalFile(index)
                                                            }}/>}</td>
                                                    </tr>
                                                )}
                                                {(this.state.income.financialTransactionFileList && this.state.income.financialTransactionFileList.length === 0) &&
                                                    <tr>
                                                        <td colSpan="8">Kayıt bulunamadı</td>
                                                    </tr>
                                                }

                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col sm="12">
                                            <p style={{float: "right"}}>Toplam
                                                Adet: {this.state.income.financialTransactionFileList ? this.state.income.financialTransactionFileList.length : 0}</p>
                                        </Col>
                                    </Row>
                                    {this.validateMessage('tTransactionChannel') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTransactionChannel" delay={0}>
                                            {this.validateMessage("tTransactionChannel")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <Label style={{color: "red", fontWeight: "bold", size: "10px"}}> Nakit harici gelir
                                tahsilatlarınızın tamamında işleme dair dosya(makbuz, slip vb.) yüklemek
                                zorunludur!</Label>
                        </div>
                    </div>
                </div>
                {/* CARD FOOTER */}
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                Vazgeç
                            </button>
                        </div>
                        <div className="col-sm-3"/>
                        {!this.state.isCancelled && <div className='col-sm-4'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#da0710', padding: '10px 40px 10px 20px', width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    disabled={this.state.isLoading || !this.state.income.id || (this.state.income && this.state.income.transferredTo)}
                                    onClick={this.cancelReceipt}>
                                Geliri İptal Et
                            </button>
                        </div>}
                        {this.state.isCancelled === true && <div className='col-sm-4'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#2662da', padding: '10px 40px 10px 10px', width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    disabled={this.state.isLoading || !this.state.income.id || (this.state.income && this.state.income.transferredTo)}
                                    onClick={this.revertCancelReceipt}>
                                Gelir İptali Geri Al
                            </button>
                        </div>}
                        <div className="col-sm-1"/>
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"180px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.isLoading || (this.state.income && this.state.income.transferredTo)}
                                    onClick={() => this.saveIncome()}>{this.state.income && this.state.income.id ? 'Güncelle' : 'Kaydet'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderIsNotMember() {
        let tTransactionDate = this.state.income.transactionDate ? {value: this.state.income.transactionDate} : {};
        const numberMask = createNumberMask({
            prefix: '',
            suffix: ' ₺',
            allowDecimal: true,
            decimalSymbol: ',',
            includeThousandsSeparator: false,
        });
        let incomeTypes = [];
        if (this.props.channel && this.props.channel === "accrual")
            incomeTypes = this.state.incomeTypes.filter(item => item.value.toString() === "1" || item.value.toString() === "2");
        else
            incomeTypes = this.state.incomeTypes;

        return (
            <div className='financial-transaction-form-container'>
                {/* HEADER */}
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'/>
                <div className="card-body" style={{marginTop:"10px"}}>
                    <div className="FormRenk col-sm-12">

                        {(this.state.income.isTransferred && this.state.income.transferredTo && (this.state.income.transferredTo === this.props.currentUser.realm)) &&
                            <div className="col-sm-12">
                                <Label style={{
                                    color: "red",
                                    size: "10px"
                                }}>{"Bu gelir işlemi  " + moment(this.state.income.transferDate).format("DD.MM.YYYY") +
                                    " tarihinde " + this.props.allBranches.filter(item => item.value === this.state.income.branchId.toString())[0].label + " 'ndan odanıza transfer edilmiştir. Üzerinde Değişiklik Yapamazsınız!"}</Label>
                            </div>
                        }
                        {(this.state.income.isTransferred && this.state.income.transferredTo && (this.state.income.branchId !== this.props.currentUser.realm)) &&
                            <div className="col-sm-12">
                                <Label style={{
                                    color: "red",
                                    size: "10px"
                                }}>{"Bu gelir işlemi  " + moment(this.state.income.transferDate).format("DD.MM.YYYY") +
                                    " tarihinde " + this.props.allBranches.filter(item => item.value === this.state.income.branchId.toString())[0].label + " 'ndan " +
                                    this.props.allBranches.filter(item => item.value === this.state.income.transferredTo.toString())[0].label + " 'na transfer edilmiştir."}</Label>
                            </div>
                        }
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Kişi/Şirket Adı *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tTitle')}>
                                    <input className="form-control"
                                           type="text"
                                           name="transactionTitle"
                                           id="tTitle"
                                           data-vlength="1,255"
                                           onBlur={this.validateField}
                                           ref="tTitle"
                                           value={this.state.income.transactionTitle}
                                           onChange={(e) => this.onChangeIncome(e)}
                                    />
                                    {this.validateMessage('tTitle') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTitle" delay={0}>
                                            {this.validateMessage("tTitle")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tahsil Eden: *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tReceivedBy')}>
                                    <input className="form-control"
                                           type="text"
                                           name="receivedBy"
                                           id="tReceivedBy"
                                           maxLength="255"
                                           data-vlength="1,255"
                                           onBlur={this.validateField}
                                           ref="tReceivedBy"
                                           value={this.state.income.receivedBy}
                                           onChange={(e) => this.onChangeIncome(e)}
                                    />
                                    {this.validateMessage('tReceivedBy') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tReceivedBy" delay={0}>
                                            {this.validateMessage("tReceivedBy")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tarih: *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tTransactionDate')}>
                                    <DatePicker {...tTransactionDate}
                                                locale={locale}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="transactionDate"
                                                id="tTransactionDate"
                                                ref="tTransactionDate"
                                        //style={{ width: 150,maxWidth:250 }}
                                                inputProps={{'vdata': "required"}}
                                                onChange={(dateString) => this.onChangeIncomeDate("transactionDate", dateString)}
                                    />
                                    {this.validateMessage('tTransactionDate') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTransactionDate" delay={0}>
                                            {this.validateMessage("tTransactionDate")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12  row">
                            <Label className="col-sm-3">E-Makbuz Üretilmesin</Label>
                            <div className={"col-sm-9 form-group"}>
                                <Label style={{color: 'red', fontSize: 'x-small'}}>
                                    <input
                                        type="checkbox"
                                        name="notCreateReceipt"
                                        checked={this.state.income.notCreateReceipt}
                                        onChange={(e) => this.onChangeCheckBox(e)}
                                        disabled={this.state.income.id}
                                    />
                                    {'  Sistem olmadığında elden verilen makbuzların yüklenmesi için geçerlidir!'}
                                </Label>
                            </div>
                        </div>
                        {this.state.income.transactionItemList && this.state.income.transactionItemList.map((transactionItem, index) =>
                            <div>
                                <div className='col-sm-12 row'>
                                    <div className="col-sm-3">
                                        {(index === 0) && <label>Gelir Kalemleri*:</label>}
                                    </div>
                                    <div className="col-sm-1">
                                        <label style={{fontWeight: "bold"}}>{index + 1 + ":"}</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className={"form-group" + this.validateClass('tItemDetail' + index)}>
                                            <input className="form-control"
                                                   placeholder="Açıklama"
                                                   type="text"
                                                   name={"itemDetail"}
                                                   id={"tItemDetail" + index}
                                                   maxLength="50"
                                                   data-vlength="1,255"
                                                   onBlur={this.validateField}
                                                   ref={"tItemDetail" + index}
                                                   value={transactionItem.itemDetail}
                                                   onChange={(e) => this.onChangeItem(e, index)}
                                            />
                                            {this.validateMessage('tItemDetail' + index) !== "" &&
                                                <UncontrolledTooltip placement="right" target={"tItemDetail" + index}
                                                                     delay={0}>
                                                    {this.validateMessage("tItemDetail" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className={"form-group" + this.validateClass('tTransactionType' + index)}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Gelir Tipi Seçiniz."
                                                name={"tTransactionType" + index}
                                                //style={{ width: 250}}
                                                inputProps={{'vdata': "required"}}
                                                ref={"tTransactionType" + index}
                                                id={"tTransactionType" + index}
                                                options={incomeTypes.filter(item => !(item.label.includes("AİDAT")))}
                                                onChange={(value) => this.onItemSelectChange("transactionTypeId", value, index)}
                                                value={this.state.income.transactionItemList[index].transactionTypeId}
                                            />
                                            {this.validateMessage('tTransactionType' + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"tTransactionType" + index}
                                                                     delay={0}>
                                                    {this.validateMessage("tTransactionType" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 row">
                                    <div className="col-sm-3"/>
                                    <div className="col-sm-1"/>
                                    <div className="col-sm-4">
                                        <div
                                            className={"form-group" + this.validateClass('tTransactionChannel' + index)}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Gelir Kanalı Seçiniz."
                                                name={"tTransactionChannel" + index}
                                                //style={{ width: 250}}
                                                ref={"tTransactionChannel" + index}
                                                id={"tTransactionChannel" + index}
                                                inputProps={{'vdata': "required"}}
                                                options={this.props.transactionChannels}
                                                onChange={(value) => this.onItemSelectChange("transactionChannelId", value, index)}
                                                value={this.state.income.transactionItemList[index].transactionChannelId}
                                            />
                                            {this.validateMessage('tTransactionChannel' + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"tTransactionChannel" + index} delay={0}>
                                                    {this.validateMessage("tTransactionChannel" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className={"form-group" + this.validateClass('tAmount' + index)}>
                                            <Maskedinput className="form-control"
                                                         mask={numberMask}
                                                         type="text"
                                                         name={"amount"}
                                                         id={"tAmount" + index}
                                                         inputProps={{vdata: "required", vlength: '3,12'}}
                                                         placeholder="________,__₺"
                                                         onBlur={this.validateField}
                                                         ref={"tAmount" + index}
                                                         value={transactionItem.amount && transactionItem.amount.toString().replace('.', ',') + ' ₺'}
                                                         onChange={(e) => this.onChangeItemAmount(e, index)}
                                            />
                                            {this.validateMessage('tAmount' + index) !== "" &&
                                                <UncontrolledTooltip placement="right" target={"tAmount" + index}
                                                                     delay={0}>
                                                    {this.validateMessage("tAmount" + index)}
                                                </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                                {(this.state.income.transactionItemList.length !== index + 1) &&
                                    <div className='col-sm-12 row'>
                                        <div className="col-sm-3"/>
                                        <div className="col-sm-1"/>
                                        <div className="col-sm-8">
                                            <hr/>
                                        </div>
                                    </div>}
                            </div>
                        )}
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3"/>
                            <div className="col-sm-6">
                                <button className='add-new-item' onClick={() => {
                                    this.addItem()
                                }}/>
                                <button className='remove-item' onClick={() => {
                                    this.removeItem()
                                }}/>
                            </div>

                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Toplam Tutar:</label>
                            </div>
                            <div className="col-sm-5">
                                <div className="kjhkjh">
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <Maskedinput className="form-control"
                                             mask={numberMask}
                                             type="text"
                                             disabled={true}
                                             name="totalAmount"
                                             id="tTotalAmount"
                                             placeholder="________,__₺"
                                             value={this.state.income.amount && this.state.income.amount.toString().replace('.', ',') + ' ₺'}
                                />
                            </div>
                        </div>

                        <div className='col-sm-12 row mt-2'>
                            <div className="col-sm-3">
                                <label>Gelir Dosyaları *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tTransactionFile')}>
                                    <Dropzone
                                        accept=".pdf, .jpeg, .jpg, .png"
                                        activeClassName="dropzoneActiveClass"
                                        className="FormRenk3 col-sm-12"
                                        multiple={true}
                                        onDrop={this.onDrop}
                                        id="tTransactionFile"
                                    >
                                        <div className="dropzoneInnerArea row">
                                            <img alt="" className="add" src={require('../../icons8-plus-48_blue.png')}/>
                                            <span className="dropzoneInnerAreaText">Dosya(.pdf, .jpeg, .png) yüklemek için tıklayınız.</span>
                                        </div>
                                    </Dropzone>
                                    <Row>
                                        <Col sm="12" style={{
                                            paddingTop: "0px",
                                            paddingRight: "15px",
                                            paddingLeft: "15px",
                                            maxHeight: '500px',
                                            overflow: "auto"
                                        }}>
                                            <table className="" style={{textAlign: 'center', paddingBottom: "5px", width:"100%"}}>
                                                <thead>
                                                <tr style={{backgroundColor: '#ebedf0'}}>
                                                    <th width="5%">#</th>
                                                    <th>Dosya Adı</th>
                                                    <th width="10%">Görüntüle</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.income.financialTransactionFileList && this.state.income.financialTransactionFileList.map((document, index) =>
                                                    <tr key={index + "_" + document.name + "_"}>
                                                        <td>{index + 1}</td>
                                                        <td style={{margin: "0px", textAlign: "left"}}>{
                                                            <TextOverFlowTooltip text={document.name || "-"}
                                                                                 maxLength={30}/>}</td>
                                                        <td style={{margin: "0px"}}>{<Button
                                                            className={this.state.isItemLoading ? 'preview-button-loading' : 'preview-button'}
                                                            disabled={this.state.isItemLoading}
                                                            onClick={async () => {
                                                                (this.state.income.financialTransactionFileList[index].content !== '')
                                                                    ?
                                                                    this.saveFile(index)
                                                                    :
                                                                    await this.downloadOriginalFile(index)
                                                            }}/>}</td>
                                                    </tr>
                                                )}
                                                {(this.state.income.financialTransactionFileList && this.state.income.financialTransactionFileList.length === 0) &&
                                                    <tr>
                                                        <td colSpan="8">Kayıt bulunamadı</td>
                                                    </tr>
                                                }

                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col sm="12">
                                            <p style={{float: "right"}}>Toplam
                                                Adet: {this.state.income.financialTransactionFileList ? this.state.income.financialTransactionFileList.length : 0}</p>
                                        </Col>
                                    </Row>
                                    {this.validateMessage('tTransactionChannel') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tTransactionChannel" delay={0}>
                                            {this.validateMessage("tTransactionChannel")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <Label style={{color: "red", fontWeight: "bold", size: "10px"}}> Nakit harici gelir
                                tahsilatlarınızın tamamında işleme dair dosya(makbuz, slip vb.) yüklemek
                                zorunludur!</Label>
                        </div>
                    </div>
                </div>
                {/* CARD FOOTER */}
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                Vazgeç
                            </button>
                        </div>
                        <div className="col-sm-3"/>
                        {!this.state.isCancelled && <div className='col-sm-4'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#da0710', padding: '10px 40px 10px 20px', width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    disabled={this.state.isLoading || !this.state.income.id || (this.state.income && this.state.income.transferredTo)}
                                    onClick={this.cancelReceipt}>
                                Geliri İptal Et
                            </button>
                        </div>}
                        {this.state.isCancelled === true && <div className='col-sm-4'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#2662da', padding: '10px 40px 10px 10px', width:"180px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    disabled={this.state.isLoading || !this.state.income.id || (this.state.income && this.state.income.transferredTo)}
                                    onClick={this.revertCancelReceipt}>
                                Gelir İptali Geri Al
                            </button>
                        </div>}
                        <div className="col-sm-1"/>
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"180px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.isLoading || (this.state.income && this.state.income.transferredTo)}
                                    onClick={() => this.saveIncome()}>{this.state.income && this.state.income.id ? 'Güncelle' : 'Kaydet'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (<div>
            <div style={{paddingLeft: '84px'}} className="col-sm-12  row">
                <Label className="col-sm-3">Birlik üyesi mi? </Label>
                <div className={"col-sm-9 form-group"}>
                    <input
                        type="checkbox"
                        name="isMember"
                        checked={this.state.income.isMember}
                        onChange={(e) => this.onChangeCheckBox(e)}
                    />
                </div>
            </div>
            {this.state.income.isMember ? this.renderIsMember() : this.renderIsNotMember()}
            <div>
                <Modal isOpen={this.state.uyariModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelPaymentCreation}>Hatırlatma</ModalHeader>
                    <ModalBody>
                        <h2>Son ödeme tarihinize 3 günden az kaldı!</h2>
                    </ModalBody>
                </Modal>
            </div>
        </div>)
    }
}

export default IncomeForm;



// WEBPACK FOOTER //
// ./src/page/financial/IncomeForm.js